import Vue from 'vue';

Vue.component('vuetable-pump-test', () =>
    import(/* webpackChunkName: 'pump-test-index' */ './vuetable-pump-test.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/pump-test/index.js